import { render, staticRenderFns } from "./bdWage.vue?vue&type=template&id=21f5b571"
import script from "./bdWage.vue?vue&type=script&lang=js"
export * from "./bdWage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f5b571')) {
      api.createRecord('21f5b571', component.options)
    } else {
      api.reload('21f5b571', component.options)
    }
    module.hot.accept("./bdWage.vue?vue&type=template&id=21f5b571", function () {
      api.rerender('21f5b571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/bdWage.vue"
export default component.exports